<template>
	<div class="main-wrap">
		<Main />
		<Review />
		<dont-give-up />

		<now-be-success />
		<AnywherePc v-if="userDevice === 'desktop'" />
		<AnywhereMobile v-else />
		<editing-pc v-if="userDevice === 'desktop'" />
		<editing-mobile v-else />
		<easy-to-start-pc v-if="userDevice === 'desktop'" />
		<easy-to-start-mobile v-else />
		<report-pc v-if="userDevice === 'desktop'" />
		<report-mobile v-else />
		<you-can-do-it />
		<interview />
		<!-- <Price /> -->
		<action />
		<Footer />
	</div>
</template>

<script>
import Main from '../components/Main'
import Review from '../components/Review'
import DontGiveUp from '@/components/DontGiveUp.vue'
import NowBeSuccess from '@/components/NowBeSuccess.vue'
import AnywherePc from '@/components/AnywherePc.vue'
import AnywhereMobile from '@/components/AnywhereMobile.vue'
import EditingPc from '@/components/EditingPc.vue'
import EditingMobile from '@/components/EditingMobile.vue'
import ReportPc from '@/components/ReportPc.vue'
import YouCanDoIt from '@/components/YouCanDoIt.vue'
import Interview from '@/components/Interview.vue'
import Action from '@/components/Action.vue'
import Footer from '@/components/Footer.vue'
import ReportMobile from '@/components/ReportMobile.vue'
import EasyToStartMobile from '@/components/EasyToStartMobile.vue'
import EasyToStartPc from '@/components/EasyToStartPc.vue'
// import Price from '@/components/Price.vue'

export default {
	name: 'home-view',
	components: {
		Main,
		Review,
		DontGiveUp,
		AnywherePc,
		AnywhereMobile,
		NowBeSuccess,
		EditingPc,
		EditingMobile,
		ReportPc,
		YouCanDoIt,
		Interview,
		Action,
		Footer,
		ReportMobile,
		EasyToStartMobile,
		EasyToStartPc,
		// Price,
	},
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
	},
	created() {
		this.setLanguageFromParam()
	},
	methods: {
		setLanguageFromParam() {
			const languageOfParam = this.$route.params.language
			if (languageOfParam === 'ja' || languageOfParam === 'jp') {
				this.$store.commit('setLanguage', 'ja')
			} else this.$store.commit('setLanguage', 'ko')
		},
	},
}
</script>

<style lang="scss" scoped>
.main-wrap {
	min-width: 375px;
	overflow-x: scroll;
}
@media screen and (min-width: 600px) {
	.main-wrap {
		min-width: 980px;
	}
}
</style>
